module.exports = __webpack_public_path__ + "img/advertisement.6af18682.jpg";